export default __webpack_public_path__ + "static/a-check-2275b323855632a3d01fdb7caf19794b.jpg";